// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../store/auth-context";

function readStoredProfileComplete() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return false;
    const user = JSON.parse(raw);
    return user?.isProfileComplete === true || user?.is_profile_complete === true;
  } catch {
    return false;
  }
}

const ProtectedRoute = ({ children }) => {
  const { isAccountActive, isLoading, isProfileComplete } = useContext(AuthContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAccountActive) {
    return <Navigate to="/account-disabled" replace />;
  }

  // Also trust localStorage so a post-complete navigate can't race React state.
  const profileComplete = isProfileComplete || readStoredProfileComplete();
  if (!profileComplete) {
    return <Navigate to="/get-started" replace />;
  }

  return children;
};

export default ProtectedRoute;
